import React, { useState, useEffect, useRef, Fragment } from "react";
// import { IdataMenuType } from "./SidebarStaticDropDown";
import { useNavigate, useLocation, Link } from "react-router-dom";

// === Styled ===
// import {
//     SidebarLabel,
//     SidebarWrap,
//     WrapMenuContent,
//     WrapItemSubNav,
//     WrapIconMUI,
//     WrapSubIconMUI,
// } from "./Styled_Sidebar";

// === ICON MUI ===
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Typography from "@mui/material/Typography";
import CardActionArea from "@mui/material/CardActionArea";
import * as MuiIcons from '@mui/icons-material'
import { ManageAccountsRounded } from "@mui/icons-material";
import { Avatar, Collapse, Tooltip } from "@mui/material";
import { SidebarLabel, SidebarWrap, WrapIconMUI, WrapItemSubNav, WrapMenuContent, WrapSubIconMUI } from "components/SidebarStaticDropDown/Styled_Sidebar";
import { IdataMenuType } from "components/SidebarStaticDropDown/SidebarStaticDropDown";
import { currentLanguage } from "service/CommonFunction/AxiosConfig";
// ====== MAPPING_ICON ======

type SubNavProps = {
    sKey: any;
    dataMenu?: IdataMenuType;
    sidebar?: boolean;
    LayoutMin900?: boolean;
    fnShowSidebar?: VoidFunction | null;
    IsDrawerMenu?: any;
    setIsDrawerMenu?: any;
    isShowIcon?: boolean;
};

const ListSubMenu: React.FC<SubNavProps> = ({
    sKey,
    dataMenu,
    sidebar,
    fnShowSidebar,
    LayoutMin900,
    IsDrawerMenu,
    setIsDrawerMenu,
    isShowIcon
}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [subnav, setSubnav] = useState<boolean>(false);
    const [sPathPrdService] = useState(["/reqtrainin", "/reqservice", "/reqproduct", "/Front/Prod", "/Front/Serv", "/Front/Trai", "/Front/Deta", "/Front/Publ"])
    const [cActivePath, setcActivePath] = useState(false)

    const showSubnav = (pathURL: string | undefined, dataMenu) => {
        // ถ้า Sidebar ปิดอยู่ให้เปิด / ถ้าเปิดอยู่แล้วมี SubNav ให้เปิด / ถ้าไม่มีเข้าลิ้ง
        setSubnav(false);
        sidebar
            ? fnShowSidebar && fnShowSidebar()
            : dataMenu?.lstSubMenu
                ? setSubnav(!subnav)
                : GotoPath(pathURL);

    };

    useEffect(() => {
        if (sidebar) {
            setSubnav(false);
        }
    }, [sidebar]);

    const GotoPath = (pathURL: string | any) => {
        
        if (pathURL) {
            navigate(pathURL)
            setSubnav(dataMenu?.lstSubMenu != null && dataMenu?.lstSubMenu.length > 0 ? true : false);
            if(setIsDrawerMenu)
            {
                setIsDrawerMenu(false)
            }
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            });
        }
    };

    const IconRender = (name, nlevel) => {
        let JSXIcon = <ManageAccountsRounded />;
        if (name) {
            const Icon = MuiIcons[name]
            if (nlevel === 1) {
                JSXIcon = <Icon style={{ color: '#ffffff', fontSize: '24px' }} />

            }
            else if (nlevel === 2) {
                JSXIcon = <Icon style={{ color: '#004290', fontSize: '24px' }} />
            }
        }
        return JSXIcon;
    }

    return (
        <div style={{ padding: "0.2rem 1rem" }}>
            <Fragment key={sKey}>
                <CardActionArea sx={{ borderRadius: "10px" }}>
                    {dataMenu?.sMenuLink ?
                        <Link to={dataMenu?.sMenuLink || "#"}>
                            <Tooltip title={currentLanguage() == "th" ? dataMenu?.sMenuNameTH : dataMenu?.sMenuNameENG} placement="right">
                                <SidebarWrap
                                    onClick={() => showSubnav(dataMenu?.sMenuLink, dataMenu)}
                                    activeurl={(location?.pathname).includes(dataMenu?.sMenuLink) ? 1 : 0}
                                >
                                    {
                                        isShowIcon == true ?
                                            <Avatar
                                                variant="rounded"
                                                style={{
                                                    margin: '8px',
                                                    width: '30px',
                                                    height: '30px',
                                                    backgroundColor: dataMenu?.sMenuLink === location?.pathname ? "#3f6ad8" : "#778a9c"
                                                }}
                                            >

                                                <WrapIconMUI>
                                                    {dataMenu?.sIcon ? IconRender(dataMenu?.sIcon, 1) : <ManageAccountsRounded />}
                                                </WrapIconMUI>
                                            </Avatar>
                                            :
                                            <div style={{ minHeight: '40px', minWidth: '24px' }}></div>
                                    }

                                    <SidebarLabel sidebar={sidebar ? 1 : 0}>
                                        <WrapMenuContent subnav={subnav ? 1 : 0}>
                                            <Typography variant="subtitle1" style={{ color: dataMenu?.sMenuLink === location?.pathname ? "#3f6ad8" : '#1e456c' }}>
                                                {currentLanguage() == "th" ? dataMenu?.sMenuNameTH : dataMenu?.sMenuNameENG}
                                            </Typography>
                                            {dataMenu?.lstSubMenu != null && dataMenu?.lstSubMenu.length > 0 ?
                                                <KeyboardArrowDownIcon
                                                    className={"rotate-Icon"}
                                                    sx={{ mr: "1rem", transition: "transform 250ms" }}
                                                />
                                                : null}
                                        </WrapMenuContent>
                                    </SidebarLabel>
                                </SidebarWrap>
                            </Tooltip>
                        </Link>
                        :
                        <Tooltip title={currentLanguage() == "th" ? dataMenu?.sMenuNameTH : dataMenu?.sMenuNameENG} placement="right" disableHoverListener={!sidebar}>
                            <SidebarWrap
                                onClick={() => showSubnav(dataMenu?.sMenuLink, dataMenu)}
                                activeurl={dataMenu?.sMenuLink === location?.pathname ? 1 : 0}
                            >
                                {
                                    isShowIcon == true ?
                                        <Avatar
                                            variant="rounded"
                                            style={{
                                                margin: '8px',
                                                width: '30px',
                                                height: '30px',
                                                backgroundColor: dataMenu?.sMenuLink === location?.pathname ? "#1e90ff" : "#778a9c"
                                            }}>
                                            <WrapIconMUI>
                                                {dataMenu?.sIcon ? IconRender(dataMenu?.sIcon, 1) : <ManageAccountsRounded />}
                                            </WrapIconMUI>
                                        </Avatar>
                                        :
                                        <div style={{ minHeight: '40px', minWidth: '24px' }}></div>
                                }
                                <SidebarLabel sidebar={sidebar ? 1 : 0}>
                                    <WrapMenuContent subnav={subnav ? 1 : 0}>
                                        <Typography variant="subtitle1" style={{ color: '#1e456c' }}>
                                            {currentLanguage() == "th" ? dataMenu?.sMenuNameTH : dataMenu?.sMenuNameENG}
                                        </Typography>
                                        {dataMenu?.lstSubMenu && (
                                            <KeyboardArrowDownIcon
                                                className={"rotate-Icon"}
                                                sx={{ mr: "1rem", transition: "transform 250ms" }}
                                            />
                                        )}
                                    </WrapMenuContent>
                                </SidebarLabel>
                            </SidebarWrap>
                        </Tooltip>
                    }
                </CardActionArea>
                <Collapse in={subnav} timeout="auto" unmountOnExit style={{ width: '100%', paddingLeft: "35px" }}>
                    {
                        //for pruduc and service
                        dataMenu?.sMenuLink == null && dataMenu?.nMenuID == 2 ?
                            <>
                                {
                                    dataMenu?.lstSubMenu?.map((item, idx) => {
                                        return (
                                            <div key={item?.nMenuID + "" + idx.toString()} style={{ width: "100%" }}>
                                                <Typography style={{color:'#504a88'}}>
                                                    {item.sType}
                                                </Typography>
                                                {
                                                    item.lstmenu != null && item.lstmenu.length > 0 ?
                                                        item.lstmenu?.map((itemSub, idxSub) => {
                                                            return (
                                                                <Fragment key={`prs_${idxSub}`}>
                                                                <CardActionArea key={`s_${idxSub}`} sx={{ borderRadius: "10px" }} className="Sub-Card">
                                                                    <div>
                                                                        <Link to={itemSub?.sLink || "#"}>
                                                                            <WrapItemSubNav
                                                                                onClick={() => GotoPath(itemSub?.sLink)}
                                                                                activeurl={0}
                                                                                // activeurl={sPathPrdService.includes(location.pathname.substring(0, 11)) ? 1 : 0}
                                                                            >
                                                                                <WrapMenuContent>
                                                                                    <Typography
                                                                                        variant="subtitle2"
                                                                                        gutterBottom
                                                                                        component="div"
                                                                                        sx={{ pt: "7px" }}
                                                                                    >
                                                                                        {itemSub?.sName}
                                                                                    </Typography>
                                                                                </WrapMenuContent>
                                                                            </WrapItemSubNav>
                                                                        </Link>
                                                                    </div>
                                                                </CardActionArea>
                                                                </Fragment>
                                                                
                                                            )
                                                        })
                                                        :
                                                        null
                                                }

                                            </div>
                                        );
                                    })
                                }
                            </>
                            :
                            <>
                                {
                                    dataMenu?.lstSubMenu?.map((item, idx) => {
                                        return (
                                            <div id={`tab_menu_${item?.nMenuID.toString()}`} key={item?.nMenuID + "" + idx.toString()} style={{ width: "100%" }}>
                                                <CardActionArea sx={{ borderRadius: "10px" }} className="Sub-Card">
                                                    <div>
                                                        <Link to={item?.sMenuLink || "#"}>
                                                            <WrapItemSubNav
                                                                onClick={() => GotoPath(item?.sMenuLink)}
                                                                activeurl={(item?.sMenuLink === location?.pathname) || (location?.pathname).includes(dataMenu?.sMenuLink)  || (location?.pathname == "/Backend/Admin/UserPermissionForm" && item?.sMenuLink == "/Backend/Admin/UserPermissionList") || (location?.pathname == "/Backend/Admin/CustomerForm" && item?.sMenuLink == "/Backend/Admin/CustomerList")? 1 : 0}
                                                            >
                                                                {/* <WrapSubIconMUI>
                                                                                    {item?.sIcon ? IconRender(item?.sIcon, 2) : null}
                                                                                </WrapSubIconMUI> */}
                                                                <WrapMenuContent>
                                                                    <Typography
                                                                        variant="subtitle2"
                                                                        gutterBottom
                                                                        component="div"
                                                                        sx={{ pt: "7px" }}
                                                                    >
                                                                        {item?.sMenuNameTH}
                                                                    </Typography>
                                                                </WrapMenuContent>
                                                            </WrapItemSubNav>
                                                        </Link>
                                                    </div>
                                                </CardActionArea>
                                            </div>
                                        );
                                    })
                                }
                            </>

                    }
                </Collapse>
            </Fragment >
        </div >
    );
};

export default ListSubMenu;
